import {
  Query_ClientReports_OptionsInput,
  useClientReportTableQuery
} from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  startDate: DateTime;
  endDate: DateTime;
  createdAt: DateTime;
  approvedBy: string;
  approvedDate: DateTime | null;
  eventCount: {
    deliveries: number;
    milestones: number;
    inspections: number;
  };
}

export function useQuery(options: Query_ClientReports_OptionsInput) {
  const tuple = useClientReportTableQuery({
    variables: {
      options
    },
    skip: options.filter?.projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.clientReports.map((node) => ({
        id: node.id,
        startDate: node.startDate,
        endDate: node.endDate,
        createdAt: node.createdAt,
        approvedBy: node.approvedBy?.fullName ?? '',
        approvedDate: node.approvedAt ?? null,
        eventCount: {
          deliveries: node.deliveries.length ?? 0,
          milestones: node.milestones.length ?? 0,
          inspections: node.inspections.length ?? 0
        }
      })) ?? [];
      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
